var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", height: "100%", "overflow-y": "auto" } },
    [
      _vm.showActualizarDatos
        ? _c("ModalActualizarDatos", {
            attrs: {
              edittelefono: _vm.edit_telefono,
              editmail: _vm.edit_mail,
              nombre: _vm.nombre
            },
            on: { cerrarActualizarDatos: _vm.handleCierreModalActualizar }
          })
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { width: "75%", height: "100%" } },
        [
          _vm.elementosInformacion.length == 1
            ? _c("informacion", {
                staticStyle: { height: "100px" },
                attrs: { elemento: _vm.elementosInformacion, show: true }
              })
            : _vm.elementosInformacion.length > 1
            ? _c("CarrouselInformativa", {
                attrs: { elementos: _vm.elementosInformacion }
              })
            : _vm._e(),
          _c("v-divider"),
          _c(
            "div",
            {
              staticClass: "contieneAmbos",
              staticStyle: { display: "flex", "flex-direction": "column" }
            },
            [
              _c(
                "v-container",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: { fluid: "", "grid-list-md": "" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "SolucionesGps",
                      staticStyle: { height: "78%" }
                    },
                    [
                      _c("hr", {
                        staticStyle: {
                          color: "yellow",
                          background: "yellow",
                          border: "none"
                        },
                        attrs: { width: "4%", size: "10px" }
                      }),
                      _c(
                        "h2",
                        {
                          staticStyle: { "font-size": "18pt", color: "#27488E" }
                        },
                        [
                          _vm._v(
                            "\n            Soluciones Gps Chile\n          "
                          )
                        ]
                      ),
                      _c(
                        "v-layout",
                        {
                          staticStyle: { display: "flex" },
                          attrs: { xs4: "", md8: "", xl8: "", wrap: "" }
                        },
                        [
                          _vm.mostrarAvlTrack
                            ? _c("chip-app", {
                                attrs: {
                                  colorIsotipo: "azul",
                                  titulo: "Track",
                                  colorTexto: "white",
                                  cargado: true,
                                  link:
                                    _vm.url_avl_track + _vm.getCurrentToken(),
                                  externa: true,
                                  tituloHover:
                                    "Seguridad, control y gestión segundo a segundo"
                                }
                              })
                            : _vm._e(),
                          _vm.mostrarOrvis && _vm.appNames.includes("Orvis")
                            ? _c("chip-app", {
                                attrs: {
                                  colorIsotipo: "azul",
                                  titulo: "Orvis",
                                  colorTexto: "white",
                                  link: "http://orvis.gpschile.com",
                                  externa: true,
                                  cargado: true,
                                  tituloHover:
                                    "Visibilidad y control en todo momento"
                                }
                              })
                            : _vm._e(),
                          _vm.mostrarDirector &&
                          _vm.appNames.includes("Director")
                            ? _c("chip-app", {
                                attrs: {
                                  colorIsotipo: "azul",
                                  titulo: "Director",
                                  colorTexto: "white",
                                  cargado: true,
                                  link:
                                    "https://director-cl.teletracnavman.net/avl3",
                                  externa: true,
                                  tituloHover:
                                    "Seguridad, control y gestión segundo a segundo"
                                }
                              })
                            : _vm._e(),
                          _vm.mostrarPeajes && _vm.appNames.includes("Peajes")
                            ? _c("chip-app", {
                                attrs: {
                                  colorIsotipo: "azul",
                                  titulo: "Peajes",
                                  colorTexto: "white",
                                  cargado: true,
                                  link: "Reportes-Peajes",
                                  tituloHover:
                                    "Audita los gastos por uso de autopistas"
                                }
                              })
                            : _vm._e(),
                          _vm.mostrarMultiflota &&
                          _vm.appNames.includes("MultiFlota")
                            ? _c("chip-app", {
                                attrs: {
                                  colorIsotipo: "azul",
                                  titulo: "MultiFlota",
                                  colorTexto: "white",
                                  cargado: true,
                                  externa: true,
                                  link: "https://multiflota.gpschile.com",
                                  tituloHover:
                                    "Centraliza la actividad de todos tus gps"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.cantidadAplicaciones > 0,
                      expression: "cantidadAplicaciones > 0"
                    }
                  ],
                  staticClass: "MisApp",
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "margin-left": "24px",
                    height: "240px"
                  }
                },
                [
                  _c("hr", {
                    staticStyle: {
                      color: "yellow",
                      background: "yellow",
                      border: "none"
                    },
                    attrs: { width: "4%", size: "10px" }
                  }),
                  _c(
                    "h2",
                    { staticStyle: { "font-size": "18pt", color: "#27488E" } },
                    [_vm._v("\n          Mis Aplicaciones\n        ")]
                  ),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _vm.mostrarAnglo && _vm.appNames.includes("Alertas")
                        ? _c("chip-app", {
                            attrs: {
                              colorIsotipo: "amarillo",
                              titulo: "Alertas",
                              colorTexto: "black",
                              cargado: true
                            }
                          })
                        : _vm._e(),
                      _vm.mostrarCosecha && _vm.appNames.includes("Cosechas")
                        ? _c("chip-app", {
                            attrs: {
                              colorIsotipo: "amarillo",
                              titulo: "Cosechas",
                              colorTexto: "black",
                              cargado: true,
                              link: "Sugal"
                            }
                          })
                        : _vm._e(),
                      _vm.mostrarAnglo && _vm.appNames.includes("Dashboard")
                        ? _c("chip-app", {
                            attrs: {
                              colorIsotipo: "amarillo",
                              titulo: "Dashboard",
                              colorTexto: "black",
                              cargado: true,
                              link: "dashboard",
                              externa: true
                            }
                          })
                        : _vm._e(),
                      _vm.mostrarAnglo && _vm.appNames.includes("Aguas")
                        ? _c("chip-app", {
                            attrs: {
                              colorIsotipo: "amarillo",
                              titulo: "Aguas",
                              colorTexto: "black",
                              cargado: true,
                              link: _vm.urldashboard,
                              externa: true
                            }
                          })
                        : _vm._e(),
                      _vm.mostrarVendimia && _vm.appNames.includes("Vendimia")
                        ? _c("chip-app", {
                            attrs: {
                              colorIsotipo: "amarillo",
                              titulo: "Vendimia",
                              colorTexto: "black",
                              cargado: true,
                              link: _vm.urldashboard
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider", {
        staticStyle: { "min-height": "100%" },
        attrs: { vertical: "" }
      }),
      _c(
        "div",
        { staticStyle: { width: "25%", height: "100%" } },
        [_c("panelInfo", { staticClass: "panelR" })],
        1
      ),
      _c("div", { staticClass: "footer" }, [
        _vm._m(0),
        _c("div", { staticClass: "containerTxtFooter" }, [
          _c(
            "p",
            {
              staticClass: "textoFooter",
              staticStyle: { "text-align": "justify" }
            },
            [_vm._v(_vm._s(_vm.txtFooter))]
          )
        ]),
        _c(
          "div",
          { staticClass: "btnFooter", staticStyle: { "padding-top": "6px" } },
          [
            _c(
              "v-btn",
              {
                staticClass: "btn-crear",
                staticStyle: {
                  "padding-right": "20px",
                  "border-radius": "50px"
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "btnFooter",
                    attrs: {
                      href: "https://www.gpschile.com/",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Gpschile.com")]
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "infoFooter",
            staticStyle: { "margin-left": "10%", "line-height": "70%" },
            attrs: { column: "" }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "400px",
                  display: "flex",
                  height: "25px",
                  "margin-top": "10px"
                }
              },
              [
                _c("v-img", {
                  attrs: {
                    "max-height": "18",
                    "max-width": "18",
                    width: "18",
                    height: "18",
                    src: require("./assetsHome/footer_icono_telefono.png")
                  }
                }),
                _c("p", { staticStyle: { "font-size": "10px" } }, [
                  _vm._v("Teléfono: +56 (2) 2940 49 11")
                ])
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: { width: "400px", display: "flex", height: "25px" }
              },
              [
                _c("v-img", {
                  attrs: {
                    "max-height": "18",
                    "max-width": "18",
                    width: "18",
                    height: "18",
                    src: require("./assetsHome/footer_icono_mail.png")
                  }
                }),
                _c("p", { staticStyle: { "font-size": "10px" } }, [
                  _vm._v("Mail: clientes@gpschile.com")
                ])
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  width: "190px",
                  display: "flex",
                  "text-align-last": "justify",
                  height: "25px"
                }
              },
              [
                _c("v-img", {
                  attrs: {
                    "max-height": "18",
                    "max-width": "18",
                    width: "18",
                    height: "18",
                    src: require("./assetsHome/footer_icono_ubicacion.png")
                  }
                }),
                _c("p", { staticStyle: { "font-size": "10px" } }, [
                  _vm._v(
                    "\n          GPS CHILE S.p.A. Cerro El Plomo 5630, of. 501 Las Condes, Santiago\n          Chile.\n        "
                  )
                ])
              ],
              1
            )
          ]
        )
      ]),
      _c("app-change-pass", {
        attrs: { show: _vm.showModalPass, primerIngreso: _vm.primerIngreso },
        on: {
          modalAsociacionEmit: function($event) {
            return _vm.moduloCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "containerLogo" }, [
      _c("div", { staticClass: "logo" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }